export default "__VITE_ASSET__CCAkxMro__"